import React from 'react'

export const NotFound = () => {
  return (
    <div className="notfound">

      <div class="cont_principal cont_error_active p-5">
        <div class="cont_error">

          <h1>Oops!</h1>
          <p>The Page you're looking for isn't here.</p>
        </div>
        <div class="cont_aura_1"></div>
        <div class="cont_aura_2"></div>
      </div>
    </div>
  )
}
